import { Repo } from "@/store/admin/repo";
import { authCookies } from "@/services/cookies";
import i18n from "../../i18n";
import toast from "@/plugins/toast";

export default function isAdmin({ next, to }) {
  const user = authCookies.getUser() || Repo.user || {};
  const requiredRole = to?.meta?.role || "ADMIN";

  if (user.type !== requiredRole) {
    toast(i18n.global.t("You are not authorized to access this page"), {
      type: "error",
    });
    return next(false);
  }

  return next();
}
